import { findPlanTakeoff } from "../fetchCables";
import type { CablePlanTakeoff } from "../fetchCables";
import type { ExcludeArchivedCablePlans } from "./types";

export const excludeArchivedCablePlans: ExcludeArchivedCablePlans = ({
  cables,
  planRecords,
}) => {
  if (!cables?.plans?.length) return cables;

  // TODO: match by a stable id once cables.json carries floor_plan_id; name matching can misfire on renames and substring collisions.
  const archivedTakeoffs = new Set<CablePlanTakeoff>();
  for (const record of planRecords) {
    if (record.archivedAt === null) continue;
    const takeoff = findPlanTakeoff(cables, record.name);
    if (takeoff !== null) archivedTakeoffs.add(takeoff);
  }
  if (archivedTakeoffs.size === 0) return cables;

  return {
    ...cables,
    plans: cables.plans.filter((plan) => !archivedTakeoffs.has(plan)),
  };
};
